import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { FEED_ITEM_VIEWS, type FeedItemKind } from '../model/feedItem';

type Props = {
  /** Вид элемента переписки */
  kind: FeedItemKind;
};

/** Подпись вида элемента переписки над облаком: текст — на языке интерфейса, заливка — из темы. */
export const RoleLabel: FC<Props> = ({ kind }) => {
  const { t } = useTranslation(['dialogs']);
  const { labelKey, labelClassName } = FEED_ITEM_VIEWS[kind];
  return (
    <span
      className={cn(
        'shrink-0 rounded-sm px-2 py-0.5 text-xs leading-4 font-semibold whitespace-nowrap text-foreground uppercase',
        labelClassName,
      )}
    >
      {t(labelKey)}
    </span>
  );
};
